// import { Button } from "@/components/ui/button";
// import { useNavigate } from "react-router-dom";
// import { useFormContext } from "@/context/form";
import { DatePickerWithRange } from "./data-picker";

interface Props {
  title?: string;
  isForm?: boolean;
  children: React.ReactNode;
    showCalendar?: boolean;
}

const PageLayout: React.FC<Props> = ({ title, showCalendar, children }) => {
  
  // Use config.showCalendar if provided, otherwise fall back to page-based logic

  // const navigate = useNavigate();
  // const routes = getRoutes();
  // const { id, isDirty, setModal } = useFormContext();

  // const onCancel = () => {
  //   if (isDirty) {
  //     return setModal(true);
  //   } else {
  //     navigate(routes.dashboard);
  //   }
  // };

  return (
    <div className="flex flex-col gap-4 px-8 py-6">
      <div className="flex justify-between items-center">
        <h2 className="text-3xl leading-9 font-semibold">{title}</h2>
        {showCalendar && <DatePickerWithRange />}
        {/* {isForm && (
          <div className="flex gap-2">
            <Button variant="outline" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              variant="default"
              type="submit"
              disabled={!isDirty}
              form={id}
            >
              Save
            </Button>
          </div>
        )} */}
      </div>
      <div className="flex flex-col gap-4">{children}</div>
    </div>
  );
};

export default PageLayout;
